module.exports = __webpack_public_path__ + "static/bg_Prizes-428becee77f6b4ac9f67787ca21433c3.jpg";